const GAUGE_COLORS = {
  negative: "#ef4444",
  positive: "#10b981",
} as const;

type DashboardGaugeChartProps = {
  progress: number;
  tone?: keyof typeof GAUGE_COLORS;
  centerLabel?: string;
};

export function DashboardGaugeChart({
  progress,
  tone = "negative",
  centerLabel,
}: DashboardGaugeChartProps) {
  const radius = 28;
  const circumference = 2 * Math.PI * radius;
  const color = GAUGE_COLORS[tone];

  return (
    <div className="relative mx-auto mt-2 flex h-[72px] w-[72px] items-center justify-center xl:mt-3 xl:h-20 xl:w-20">
      <svg viewBox="0 0 72 72" className="h-full w-full -rotate-90" aria-hidden>
        <circle cx="36" cy="36" r={radius} fill="none" stroke="#e4e4e7" strokeWidth="6" />
        <circle
          cx="36"
          cy="36"
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth="6"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference * (1 - progress)}
        />
      </svg>
      {centerLabel ? (
        <span className="absolute text-lg font-bold text-[#1C1C1C] xl:text-xl">{centerLabel}</span>
      ) : null}
    </div>
  );
}
